import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LuArrowUp, LuPaperclip } from "react-icons/lu";
import AgentChat from "../agent/AgentChat";
import { QUICK_ACTIONS } from "../agent/quickActions";
import "../agent/agent.css";
import { selectAuthenticated } from "../selectors";

/** Logged-out view: the real empty state, with the composer locked behind sign-in. */
function SignedOutAgent({ onSignIn }) {
    return (
        <div className="tryon-agent tryon-agent-surface flex h-[calc(100dvh-5rem)] min-h-[28rem] w-full items-center justify-center overflow-y-auto p-4">
            <div className="flex w-full max-w-xl flex-col items-center text-center">
                <h2 className="font-newsreader text-4xl font-medium tracking-tight text-secondary sm:text-5xl">
                    What do you want to make?
                </h2>
                <p className="mt-3 max-w-md font-Mulish text-base text-graphite">
                    Try a garment on, change a photo, or generate a look. Sign in to chat with the agent.
                </p>

                <button
                    type="button"
                    onClick={onSignIn}
                    aria-label="Sign in to start chatting"
                    className="group mt-8 w-full cursor-pointer rounded-2xl border border-[var(--border-primary)] bg-white text-left transition-[border-color,box-shadow] hover:border-primary-200 focus:outline-none focus-visible:shadow-[var(--ring)]"
                >
                    <span className="block px-3.5 pb-1 pt-3 text-sm leading-6 text-[var(--text-tertiary)]">
                        Describe what you want, or attach a photo
                    </span>
                    <span className="flex items-center justify-between px-2 pb-2 pt-1">
                        <span className="flex h-9 w-9 items-center justify-center text-primary-700">
                            <LuPaperclip size={16} />
                        </span>
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-800">
                            <LuArrowUp size={16} />
                        </span>
                    </span>
                </button>

                <div className="mt-4 flex w-full flex-wrap items-center justify-center gap-2">
                    {QUICK_ACTIONS.map(({ id, label, icon: Icon }) => (
                        <button
                            key={id}
                            type="button"
                            onClick={onSignIn}
                            className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-white px-3.5 py-1.5 font-Mulish text-sm text-primary-700 transition-colors hover:bg-primary-50"
                        >
                            <Icon size={14} />
                            {label}
                        </button>
                    ))}
                </div>

                <div className="mt-8 flex flex-col items-center gap-2">
                    <button
                        type="button"
                        onClick={onSignIn}
                        className="rounded-full bg-primary-700 px-6 py-2.5 font-Mulish text-sm font-semibold text-white shadow-[0_12px_28px_-10px_rgba(190,49,32,0.65)] hover:bg-primary-800"
                    >
                        Sign in to start chatting
                    </button>
                    <p className="font-Mulish text-[13px] text-graphite">Your chats are saved to your account.</p>
                </div>
            </div>
        </div>
    );
}

export default function TryOnAgent() {
    const authenticated = useSelector(selectAuthenticated);
    const navigate = useNavigate();

    if (authenticated === false) return <SignedOutAgent onSignIn={() => navigate("/signin")} />;
    return <AgentChat />;
}
